// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link
{
    font-family: Inter;
font-weight: 500;
font-size: 17px;
line-height: 25.15px;
letter-spacing: -5%;
text-transform: capitalize;
text-align: center;
color: #0000008F;
}
.nav-link:hover
{
    color: #0058A0;
}
.navbar-toggler
{
    background-color: #0058A0;
    color: #fff;
    border: none !important;
    outline: 0 !important;
    box-shadow: none !important;
}
.navbar-toggler-icon {
    width: 40px;
    height: 4px;
    background-color: #fff; /* Customize the color */
    border-radius: 5px;  /* Optional: add rounded corners */
  }
  @media (max-width:991px) {
.video-btn
  {
    text-align: center;
    justify-content: center;
    margin: auto;
  }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Nav/nav.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;AACtB,gBAAgB;AAChB,eAAe;AACf,oBAAoB;AACpB,mBAAmB;AACnB,0BAA0B;AAC1B,kBAAkB;AAClB,gBAAgB;AAChB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,yBAAyB;IACzB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB,EAAE,wBAAwB;IAChD,kBAAkB,GAAG,kCAAkC;EACzD;EACA;AACF;;IAEI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;EACd;EACA","sourcesContent":[".nav-link\r\n{\r\n    font-family: Inter;\r\nfont-weight: 500;\r\nfont-size: 17px;\r\nline-height: 25.15px;\r\nletter-spacing: -5%;\r\ntext-transform: capitalize;\r\ntext-align: center;\r\ncolor: #0000008F;\r\n}\r\n.nav-link:hover\r\n{\r\n    color: #0058A0;\r\n}\r\n.navbar-toggler\r\n{\r\n    background-color: #0058A0;\r\n    color: #fff;\r\n    border: none !important;\r\n    outline: 0 !important;\r\n    box-shadow: none !important;\r\n}\r\n.navbar-toggler-icon {\r\n    width: 40px;\r\n    height: 4px;\r\n    background-color: #fff; /* Customize the color */\r\n    border-radius: 5px;  /* Optional: add rounded corners */\r\n  }\r\n  @media (max-width:991px) {\r\n.video-btn\r\n  {\r\n    text-align: center;\r\n    justify-content: center;\r\n    margin: auto;\r\n  }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
